import { Box, TextField, type TextFieldProps } from '@mui/material'
import { type FormEventHandler, useEffect, useState } from 'react'

interface DirectPageInputProps {
  currentPage: number
  pageCount: number
  onPageSubmit: (page: number) => void
}

export const DirectPageInput = ({
  currentPage,
  pageCount,
  onPageSubmit,
}: DirectPageInputProps) => {
  const [nextPage, setNextPage] = useState<string>(currentPage.toString())

  const handlePageSubmit: FormEventHandler = (event) => {
    event.preventDefault()
    const nextPageInt = Number.parseInt(nextPage, 10)

    if (nextPageInt < 1 || Number.isNaN(nextPageInt)) {
      setNextPage('1')
      onPageSubmit(1)
      return
    }

    if (nextPageInt > pageCount) {
      const validPageCount = Math.max(pageCount, 1)
      setNextPage(validPageCount.toString())
      onPageSubmit(validPageCount)
      return
    }

    onPageSubmit(nextPageInt)
  }

  const handlePageInputChange: TextFieldProps['onChange'] = (event) => {
    setNextPage(`${event.target.value}`)
  }

  useEffect(() => {
    setNextPage(currentPage.toString())
  }, [currentPage])

  return (
    <Box display="flex" alignItems="baseline" gap={1}>
      <form onSubmit={handlePageSubmit}>
        <TextField
          size="small"
          variant="standard"
          value={nextPage}
          sx={{
            maxWidth: '8ch',
            '& .MuiInputBase-input': { textAlign: 'center' },
          }}
          type="number"
          inputMode="numeric"
          onChange={handlePageInputChange}
        />
      </form>
    </Box>
  )
}
